'use client';

import { useEffect } from 'react';
import { trackEvent } from '@/firebase'

export default () => {
  useEffect(() => {
    trackEvent('page-view', {
      page_path: window.location.pathname,
      page_title: document.title,
      page_referrer: document.referrer,
      page_host: window.location.host,
      page_hostname: window.location.hostname,
      page_protocol: window.location.protocol,
    })
  }, [])

  return null;
};